var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rank-type-item-mobile",class:_vm.on ? "on item_"+_vm.index : "item_"+_vm.index,on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v(" "+_vm._s(_vm.$t(_vm.info.title))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }